export default {
  getCep: state => state.cep,
  getAddress: state => state.address,
  getNumber: state => state.number,
  getNoNumber: state => state.noNumber,
  getNeighborhood: state => state.neighborhood,
  getState: state => state.state,
  getCity: state => state.city,
  getCityId: state => state.cityId,
  getLatitude: state => state.latitude,
  getLongitude: state => state.longitude,
  getAvailableBoxes: state => state.availableBoxes,
  getCoverageArea: state => state.coverageArea,
  getStateId: state => state.stateId,
  getSecondaryAddress: state => state.secondaryAddress,
  getCondominiumComplement: state => state.condominiumComplement,
  getBuildingComplement: state => state.buildingComplement,
  addressId: state => state.addressId,
  getProviderAddressUuid: state => state.providerAddressUuid,
  getComplements: state => state.complement,
  getCto: state => state.cto,
  getAddressGroupDescription: state => state.addressGroupDescription,
  getAddressGroupUnity: state => state.addressGroupUnity,
  getAddressGroupUnityInformation: state => state.addressGroupUnityInformation,
  getAddressGroupUnityName: state => state.addressGroupUnityName,
  getCurrentLatitude: state => state.currentLatitude,
  getCurrentLongitude: state => state.currentLongitude,
  getCepFromCurrentLocation: state => state.cepFromCurrentLocation,
  getHasMadeCepFromCurrentLocationRequest: state =>
    state.hasMadeCepFromCurrentLocationRequest,
  getLocationType: state => state.locationType,
  getReferencePoint: state => state.referencePoint
}
